module.exports = __webpack_public_path__ + "img/cf_block1.d2aa3a5e.png";